import { render } from "./Autres.vue?vue&type=template&id=b5134fa6"
import script from "./Autres.vue?vue&type=script&lang=js"
export * from "./Autres.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__